/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiDocumentEvent
 */
export interface InternalApiDocumentEvent {
    /**
     * 
     * @type {string}
     * @memberof InternalApiDocumentEvent
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiDocumentEvent
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiDocumentEvent
     */
    deletedTime?: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiDocumentEvent
     */
    createdBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiDocumentEvent
     */
    deletedBy?: InternalApiUserBasicDetails;
}

/**
 * Check if a given object implements the InternalApiDocumentEvent interface.
 */
export function instanceOfInternalApiDocumentEvent(value: object): value is InternalApiDocumentEvent {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiDocumentEventFromJSON(json: any): InternalApiDocumentEvent {
    return InternalApiDocumentEventFromJSONTyped(json, false);
}

export function InternalApiDocumentEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDocumentEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'createdTime': (new Date(json['createdTime'])),
        'deletedTime': json['deletedTime'] == null ? undefined : (new Date(json['deletedTime'])),
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'deletedBy': json['deletedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['deletedBy']),
    };
}

export function InternalApiDocumentEventToJSON(json: any): InternalApiDocumentEvent {
    return InternalApiDocumentEventToJSONTyped(json, false);
}

export function InternalApiDocumentEventToJSONTyped(value?: InternalApiDocumentEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'createdTime': value['createdTime'].toISOString(),
        'deletedTime': value['deletedTime'] == null ? value['deletedTime'] : value['deletedTime'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'deletedBy': InternalApiUserBasicDetailsToJSON(value['deletedBy']),
    };
}

